/*** IMPORTS FROM imports-loader ***/
var jQuery = require("jquery");
var $ = require("jquery");

import React from 'react';
import CSSModules from 'react-css-modules';
import styles from './styles.scss';


const defaultProps = {
  status: 'idle',
  pullRight: false,
  more: false,
  mark: null,
  reset: null,
};

const propTypes = {
  more: React.PropTypes.bool,
  mark: React.PropTypes.any,
  status: React.PropTypes.string,
  pullRight: React.PropTypes.bool,
  onNext: React.PropTypes.func.isRequired,
  onPrev: React.PropTypes.func.isRequired,
  reset: React.PropTypes.any,
};

class TablePager extends React.Component {

  constructor(props) {
    super(props);
    this.init(props.more, props.mark, props.status);
    this.handleNextPage = this.handleNextPage.bind(this);
    this.handlePrevPage = this.handlePrevPage.bind(this);
  }

  componentWillReceiveProps(nextProps) {
    const { mark, more, status = 'idle', reset } = nextProps;

    if (reset !== this.props.reset) {
      this.init(more, mark, status);
      return;
    }

    if (mark === this.props.mark &&
        more === this.props.more &&
        status === this.props.status) {
      // no changes, skip it!
      return;
    }

    this.setState({ status });
    if (status !== 'success') {
      return;
    }

    if (this.action === 'prev') {
      this.marks = _.dropRight(this.marks, 1);
      this.setState({
        hasPrev: this.marks.length > 1,
        hasNext: more,
      });
    } else if (this.action === 'next') {
      // this.marks = _.uniq(_.concat(this.marks, mark));
      this.marks = mark;
      this.setState({
        hasPrev: this.marks.length > 1,
        hasNext: more,
      });
    } else {
      // no former action
      this.marks = mark;
      this.state = {
        hasPrev: this.marks.length > 1,
        hasNext: more,
      };
      // if (more) {
      //   this.marks = [mark];
      // } else {
      //   this.marks = [];
      // }
      // this.setState({
      //   hasPrev: false,
      //   hasNext: more,
      // });
    }
  }

  init(more, mark, status) {
    this.action = null;
    this.marks = mark;
    this.state = {
      hasPrev: this.marks.length > 1,
      hasNext: more,
      status,
    };
  }

  handlePrevPage() {
    this.action = 'prev';
    let mark = '';
    if (this.marks.length > 2) {
      mark = _.last(_.dropRight(this.marks, 2));
    }
    this.props.onPrev(mark);
  }

  handleNextPage() {
    this.action = 'next';
    const mark = _.last(this.marks);
    this.props.onNext(mark);
  }

  shouldDisableNext() {
    const { status, hasNext } = this.state;
    if (status !== 'success' && status !== 'failure') {
      return true;
    }
    return !hasNext;
  }

  shouldDisablePrev() {
    const { status, hasPrev } = this.state;
    if (status !== 'success' && status !== 'failure') {
      return true;
    }
    return !hasPrev;
  }

  renderPager() {
    const { status, hasNext, hasPrev } = this.state;
    let nextIcon = <i className="fa fa-chevron-circle-right" />;
    let prevIcon = <i className="fa fa-chevron-circle-left" />;

    if (status === 'loading' || status === 'request') {
      nextIcon = <i className="fa fa-spinner fa-spin" />;
      prevIcon = <i className="fa fa-spinner fa-spin" />;
    }
    if (!hasNext) {
      nextIcon = <i className="fa fa-circle" />;
    }
    if (!hasPrev) {
      prevIcon = <i className="fa fa-circle" />;
    }

    return (
      <ul styleName="table-pager" className="list-inline">
        <li>
          <button
            styleName="pager-button"
            onClick={this.handlePrevPage}
            disabled={this.shouldDisablePrev()}
          >
            {prevIcon}
          </button>
        </li>
        <li>
          <button
            styleName="pager-button"
            onClick={this.handleNextPage}
            disabled={this.shouldDisableNext()}
          >
            {nextIcon}
          </button>
        </li>
      </ul>
    );
  }

  render() {
    const { pullRight } = this.props;

    if (pullRight) {
      return (
        <div styleName="wrapper-pull-right">
          {this.renderPager()}
        </div>
      );
    }
    return this.renderPager();
  }
}

TablePager.defaultProps = defaultProps;
TablePager.propTypes = propTypes;

export default CSSModules(TablePager, styles);




// WEBPACK FOOTER //
// ./src/components/TablePagerTDM/index.jsx